import {Page} from "../page";
import {WithAPI} from "../../api/temperature";
import {SensorsTable} from "../sensorsTable";
import {SensorSetsTable} from "../sensorSetsTable";
import {AsRoute} from "../../app";
import {useFetchAndRender} from "../fetchAndRender";
import {Column, UnevenColumns} from "../generic/columns";
import {SensorSet} from "../../api/set";
import {Button} from "../generic/button";

export type IndexProps = {} & WithAPI & AsRoute;

export function Index(props: IndexProps) {
    const [sets] = useFetchAndRender<SensorSet[]>(async () =>
        (await props.api.sets.get()).sensor_sets);

    return <Page
        class="container"
        links={<li><Button as="a" className="btn" href="/api/docs" data-native>API</Button></li>}
    >{ sets && <UnevenColumns>
            <Column>
                <SensorsTable sets={sets} api={props.api} />
            </Column>
            <Column>
                <SensorSetsTable sets={sets} />
            </Column>
        </UnevenColumns>
    }</Page>
}
